// src/unicodex_ui/pages/PrefixApplyPage.jsx
import React, { useState } from "react";
import "../styles/FormLayout.css";
import "../styles/PrefixApplyPage.css";
import TopNav from "../components/TopNav";
import FooterBar from "../components/FooterBar";
import { submitApplication } from "../services/identityApi";

function PrefixApplyPage() {
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    setSuccessMessage("");
    setErrorMessage("");

    const formData = new FormData(e.target);

    const payload = {
      legal_name: (formData.get("legal_name") || "").trim(),
      entity_type: (formData.get("entity_type") || "").trim(),
      country: (formData.get("country") || "").trim(),
      registration_number: (formData.get("registration_number") || "").trim(),
      contact_name: (formData.get("contact_name") || "").trim(),
      contact_email: (formData.get("contact_email") || "").trim(),
      contact_phone: (formData.get("contact_phone") || "").trim(),
      categories: (formData.get("categories") || "").trim(),
      regions: (formData.get("regions") || "").trim(),
    };

    // Frontend required fields check (matches backend minimal requirement)
    const requiredFields = [
      "legal_name",
      "entity_type",
      "country",
      "contact_name",
      "contact_email",
    ];
    const missing = requiredFields.filter((key) => !payload[key]);

    if (missing.length > 0) {
      setErrorMessage("Please fill in all required fields before submitting.");
      return;
    }

    setSubmitting(true);

    try {
      const data = await submitApplication(payload);

      if (!data || data.ok !== true || !data.application) {
        if (data && data.error === "missing_fields") {
          setErrorMessage(
            "Some required fields are missing. Please review the form and try again."
          );
        } else {
          setErrorMessage(
            "Unable to submit your application right now. Please try again."
          );
        }
        return;
      }

      setSuccessMessage(
        `Your application has been submitted successfully. Reference ID: ${data.application.reference_code}.`
      );
      e.target.reset();
    } catch (err) {
      console.error("[PrefixApplyPage] submit error:", err);
      setErrorMessage(
        "A network or server error occurred while submitting your application. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="ucx-body">
      <TopNav />

      <main className="ucx-main">
        <section className="ucx-section">
          <div className="ucx-container ucx-max-700">
            <h1>Apply for a UNI-CODEX Manufacturer Prefix</h1>
            <p>
              Manufacturers must obtain a UNI-CODEX prefix before product codes
              can be issued. Submit your details below.
            </p>

            <form
              className="ucx-form"
              id="ucx-prefix-form"
              onSubmit={handleSubmit}
            >
              <fieldset className="ucx-fieldset">
                <legend>Organization Details</legend>

                <label htmlFor="legal_name">Legal Entity Name</label>
                <input type="text" id="legal_name" name="legal_name" required />

                <label htmlFor="entity_type">Entity Type</label>
                <input
                  type="text"
                  id="entity_type"
                  name="entity_type"
                  placeholder="Manufacturer, Brand Owner, Distributor"
                  required
                />

                <label htmlFor="country">Country of Registration</label>
                <input type="text" id="country" name="country" required />

                <label htmlFor="registration_number">
                  Company Registration Number
                </label>
                <input
                  type="text"
                  id="registration_number"
                  name="registration_number"
                  required
                />
              </fieldset>

              <fieldset className="ucx-fieldset">
                <legend>Contact Details</legend>

                <label htmlFor="contact_name">Primary Contact Person</label>
                <input
                  type="text"
                  id="contact_name"
                  name="contact_name"
                  required
                />

                <label htmlFor="contact_email">Contact Email</label>
                <input
                  type="email"
                  id="contact_email"
                  name="contact_email"
                  required
                />

                <label htmlFor="contact_phone">Contact Phone</label>
                <input type="tel" id="contact_phone" name="contact_phone" />
              </fieldset>

              <fieldset className="ucx-fieldset">
                <legend>Product Scope (Overview)</legend>

                <label htmlFor="categories">Main Product Categories</label>
                <textarea
                  id="categories"
                  name="categories"
                  rows="3"
                  placeholder="Example: cosmetics, medical devices, nutraceuticals"
                />

                <label htmlFor="regions">Regions of Distribution</label>
                <textarea
                  id="regions"
                  name="regions"
                  rows="3"
                  placeholder="Local, regional, or global markets"
                />
              </fieldset>

              {successMessage && (
                <div className="ucx-prefix-status ucx-prefix-status-success">
                  {successMessage}
                </div>
              )}

              {errorMessage && (
                <div className="ucx-prefix-status ucx-prefix-status-error">
                  {errorMessage}
                </div>
              )}

              <button
                type="submit"
                className="ucx-btn ucx-btn-primary"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit Prefix Application"}
              </button>
            </form>

            <p className="ucx-small ucx-top-margin">
              Once approved, you will receive a UNI-CODEX prefix and onboarding
              instructions for registering your first products and batches.
            </p>
          </div>
        </section>
      </main>

      <FooterBar />
    </div>
  );
}

export default PrefixApplyPage;
